import CommonTextBox, { TextBoxProps } from '@atoms/TextBox';

export default function TextBox({ ...props }: TextBoxProps) {
  return <CommonTextBox isPipeline allowComposite asString {...props} />;
}
